var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 17.5,
    fill: "#027A48"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 19.5,
    stroke: "#027A48",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1329 13.0407L30.3584 20.5358C30.6476 20.7994 30.7432 21.2054 30.602 21.5703C30.4607 21.9351 30.1166 22.1708 29.7253 22.1708H28.4113V29.6804C28.4113 29.9781 28.1699 30.2195 27.8722 30.2195H23.3638C23.066 30.2195 22.8246 29.9781 22.8246 29.6804V25.1208H20.1748V29.6803C20.1748 29.9781 19.9334 30.2195 19.6357 30.2195H15.127C14.8293 30.2195 14.5879 29.9781 14.5879 29.6803V22.1708H13.2741C12.8829 22.1708 12.5388 21.9351 12.3974 21.5703C12.2561 21.2054 12.3517 20.7994 12.6409 20.5358L20.8665 13.0407C21.2274 12.7117 21.7718 12.7117 22.1329 13.0407ZM24.6499 13.8701H28.2707C28.5685 13.8701 28.8098 14.1114 28.8098 14.4092V17.6526L24.6499 13.8701Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.29e2f6cb0ccdb5177fb244a9ee603ecd.svg";
export { ForwardRef as ReactComponent };